import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../../redux/slices/postIdeas";
import { PostIdeasListDataTable } from "../../../components/postIdeas/postIdeasDatatable";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Toaster } from "react-hot-toast";

const PostIdeasList = () => {
  // get cloudslug from the url using useParams
  const { cloudslug } = useParams();
  const { page } = useSelector((state: any) => state.postIdeas);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchPosts(page, { cloud__slug: cloudslug }) as any);
  }, [dispatch, page, cloudslug]);
  return (
    <Container>
      <Toaster />
      <div className="card p-2 rounded">
        <PostIdeasListDataTable query={{ cloud__slug: cloudslug }} />
      </div>
    </Container>
  );
};
export default PostIdeasList;
